import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import Block from './Block';
import BodyWrapper from './BodyWrapper';

// Retrocompatibilità: i vecchi blocchi salvavano gli elementi in `subblocks`
const getItems = (data) => data.items ?? data.subblocks ?? [];

const View = ({ data, isEditMode = false, id }) => {
  return (
    <div className="block sponsors">
      {data.headline &&
        (data.headline_bg ? (
          <div className="bg-primary full-width mb-1">
            <div className="ui container">
              <h2 className="headline">{data.headline}</h2>
            </div>
          </div>
        ) : (
          <h2 className="headline">{data.headline}</h2>
        ))}
      {isEditMode && !data.headline && getItems(data).length === 0 && (
        <p className="text-center">Lista di sponsor (vuota)</p>
      )}
      <BodyWrapper>
        {getItems(data).map((item, index) => {
          const blockId = item['@id'] ? `${item['@id']}-${id}` : index;
          return (
            <Block
              key={blockId}
              data={item}
              isEditMode={isEditMode}
              id={blockId}
            />
          );
        })}
      </BodyWrapper>
    </div>
  );
};

View.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
  id: PropTypes.string,
  isEditMode: PropTypes.bool,
};

export default View;
